<template>
  <div class="block" ref="blockView" @mousemove="handleMove">
    <!-- 时间刻度 -->
    <BlockTimeScale />
    <!-- 日期卡片 -->
    <BlockDateCards
      class="block__date"
      :nomargin="nomargin"
      @initFloatMsg="initFloatMsg"
    />
    <a-drawer
      placement="right"
      :closable="false"
      :visible="drawerVisible"
      :get-container="false"
      :mask="false"
      :wrap-style="{ position: 'absolute' }"
      @close="onClose"
    >
      <BlockCategoryList class="block__categorys" />
      <div class="setting-drawer-index-handle" slot="handle">
        <div
          class="setting-drawer-togglDrawer"
          @click="togglDrawer"
          slot="handle"
        >
          <a-icon type="double-right" v-if="drawerVisible" />
          <a-icon type="double-left" v-else />
        </div>
        <!-- 更多操作 -->
        <BlockActions
          class="block__actions"
          :nomargin="nomargin"
          @togglMargin="togglMargin"
        />
      </div>
    </a-drawer>
    <!-- 分类列表 -->

    <!-- 浮动多选信息 -->
    <BlockFloatMessage
      class="block__float-msg"
      v-show="inMul"
      id="floatMsgBox"
    />
  </div>
</template>

<script>
import BlockTimeScale from "./components/BlockTimeScale";
import BlockDateCards from "./components/BlockDateCards";
import BlockCategoryList from "./components/BlockCategoryList";
import BlockActions from "./components/BlockActions";
import BlockFloatMessage from "./components/BlockFloatMessage";

import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

export default {
  components: {
    BlockTimeScale,
    BlockDateCards,
    BlockCategoryList,
    BlockActions,
    BlockFloatMessage
  },
  data() {
    return {
      nomargin: false,
      floatMsgBox: null,
      drawerVisible: true
    };
  },
  computed: {
    inMul() {
      return this.$store.getters.inMul;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getFloatMsg();
    });
  },
  methods: {
    moment,
    togglDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    getFloatMsg() {
      this.floatMsgBox = document.getElementById("floatMsgBox");
    },
    initFloatMsg({ top, left }) {
      this.setPosition(top, left);
    },
    handleMove(event) {
      if (!this.inMul) return;
      this.setPosition(event.clientY, event.clientX);
    },
    setPosition(y, x) {
      if (!this.floatMsgBox) this.getFloatMsg();
      this.floatMsgBox.style.top = y - 80 + "px";
      this.floatMsgBox.style.left = x - 120 + "px";
    },
    togglMargin() {
      this.nomargin = !this.nomargin;
    }
  }
};
</script>

<style lang="less">
.block {
  height: 100%;
  overflow: hidden;
}

.block__date {
  display: flex;
  height: 100%;
}

.block__categorys {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  position: absolute;
  right: 0;
  top: 0;
}

.float__menu {
  display: block;
  width: 160px;
  text-align: left;
  z-index: 1;
  font-size: 1.6rem;
  line-height: 1.6rem;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  white-space: normal;
  font-size: 13px;
  box-sizing: border-box;
  color: #333;
  padding: 5px 0;
}
.float__menu li {
  color: #555;
  list-style-type: none;
  border: 0;
  padding: 5px 20px;
  position: relative;
  user-select: none;
}
.float__menu .item:hover {
  background: #e9e9e9;
}

.float__menu .colorBlock {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;
  border-radius: 100%;
}

.float__menu .item:hover .shortcut-list {
  display: block;
}
.float__menu .shortcut-list {
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(100%);
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  display: none;
}
.float__menu ul {
  margin: 0;
  background: #fff;
}

.item__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.block__container {
  position: relative;
  height: 100%;
  display: flex;
  /* flex: 1; */
  white-space: nowrap;
  align-items: stretch;
  overflow: hidden;
  background-color: #fff;
}

.setting-drawer-togglDrawer {
  position: absolute;
  top: 300px;
  right: 257px;
  height: 40px;
  width: 40px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px 0 0 2px;
  border: 1px solid #d9d9d9;
  border-right: none;
  i {
    font-size: 20px;
  }
}
</style>
